import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ToggleRight } from "lucide-react";
import { featureAdoption } from "../../api/platform";
import { NeuCard } from "../../components/neu/Neu";

// اعتماد الميزات: كم شركة فعّلت كل ميزة — أساس تسعير الموديولات لاحقاً.
export const FeatureAdoption = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    featureAdoption().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return null;

  return (
    <NeuCard data-testid="feature-adoption-card">
      <div className="flex flex-wrap items-center gap-3">
        <ToggleRight className="h-5 w-5 text-primary" />
        <div>
          <h2 className="text-lg font-black">{t("features.adoption.title")}</h2>
          <p className="text-xs text-muted-foreground">
            {t("features.adoption.subtitle", { count: data.total_companies })}
          </p>
        </div>
      </div>

      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {data.rows.map((row) => (
          <div key={row.key} className="neu-in rounded-2xl p-3" data-testid={`feature-adoption-${row.key}`}>
            <div className="flex items-baseline justify-between gap-2">
              <p className="truncate text-xs font-bold">{t(`features.names.${row.key}`, { defaultValue: row.key })}</p>
              <p className="font-mono text-sm font-semibold num">
                {row.enabled}/{data.total_companies}
              </p>
            </div>
            <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-border/50">
              <div
                className="h-full rounded-full bg-primary transition-[width] duration-700"
                style={{ width: `${row.share}%` }}
              />
            </div>
            <p className="mt-1 text-[10px] text-muted-foreground num">
              {row.share}% · {t("features.adoption.active")}: {row.enabled_active}
            </p>
          </div>
        ))}
      </div>
    </NeuCard>
  );
};
